module.exports = __webpack_public_path__ + "assets/img/informationDate_third.47984920.svg";